import React, { useState } from "react";
import axios from "../api/axios";
import { useAuthContext } from "../hooks/useAuthContext";
import { useLogout } from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import { useToast } from "../context/ToastContext";
import { getErrorMessage } from "../utils/errorMessage";

function Changepass() {
  const { user } = useAuthContext();
  const { logout } = useLogout();
  const nav = useNavigate();
  const { notifySuccess, notifyError, notifyLoading } = useToast();

  const [currPass, setCurrPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmNewPass, setConfirmNewPass] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Frontend quick validation (optional but nice)
    if (!currPass || !newPass || !confirmNewPass) {
      notifyError("Please fill in all fields.");
      return;
    }
    if (newPass !== confirmNewPass) {
      notifyError("New password confirmation does not match.");
      return;
    }
    if (newPass.length < 6) {
      notifyError("Password should be at least 6 characters.");
      return;
    }

    const toastId = notifyLoading("Updating password...");
    setSubmitting(true);

    try {
      const payload = {
        currPass,
        newPass,
        ConfirmNewPass: confirmNewPass,
      };

      const res = await axios.post("/api/user/change/password", payload, {
        headers: { accessToken: user.token },
      });

      if (res.data?.error) {
        notifyError(res.data.error, { id: toastId });
        setSubmitting(false);
        return;
      }

      if (res.data?.success) {
        notifySuccess("Password updated successfully. Please login again.", {
          id: toastId,
          duration: 2500,
        });

        // auto logout after short delay
        setTimeout(() => {
          logout();
          nav("/login");
        }, 1800);
        return;
      }

      notifyError("Unexpected response. Please try again.", { id: toastId });
      setSubmitting(false);
    } catch (err) {
      notifyError(getErrorMessage(err, "Couldn't connect to server. Please try again."), { id: toastId });
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setCurrPass("");
    setNewPass("");
    setConfirmNewPass("");
  };

  return (
    <div>
      <div className="container py-5">
        <div className="text-center mb-4">
          <h1 className="mb-1 header-title">Change Password</h1>
          <div className="text-muted" style={{ fontSize: 14 }}>
            Update your password to keep your account secure.
          </div>
  </div>

        <div className="row justify-content-center">
          {/* mobile col-12, desktop col-6 */}
          <div className="col-12 col-lg-6">
            <div className="card ds-card">
              <div className="card-body p-4">
                <div className="mb-3">
                  <div className="fw-semibold">Password Update</div>
                  <div className="text-muted" style={{ fontSize: 13 }}>
                    You will be logged out once the password is updated.
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label text-muted" style={{ fontSize: 13 }}>
                      Current Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      value={currPass}
                      onChange={(e) => setCurrPass(e.target.value)}
                      placeholder="Enter current password"
                      autoComplete="current-password"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted" style={{ fontSize: 13 }}>
                      New Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPass}
                      onChange={(e) => setNewPass(e.target.value)}
                      placeholder="Enter new password"
                      autoComplete="new-password"
                    />
                    <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                      Minimum 6 characters recommended.
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label text-muted" style={{ fontSize: 13 }}>
                      Confirm New Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      value={confirmNewPass}
                      onChange={(e) => setConfirmNewPass(e.target.value)}
                      placeholder="Re-enter new password"
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="d-flex flex-column flex-sm-row gap-2">
                    <button
                      className="btn btn-dark flex-fill"
                      type="submit"
                      disabled={submitting}
                    >
                      {submitting ? "Updating..." : "Update Password"}
                    </button>

                    <button
                      className="btn btn-outline-secondary flex-fill"
                      type="button"
                      onClick={handleReset}
                      disabled={submitting}
                    >
                      Clear
                    </button>
                  </div>
                </form>

                <hr className="my-4" />

                <div className="text-muted" style={{ fontSize: 13 }}>
                  Tip: Avoid reusing old passwords. Use a unique password for this account.
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Changepass;
